import React from 'react';
import './LoadingIndicator.css';

interface IProps {
  readonly label: string;
}

const LoadingIndicator: React.FC<IProps> = ({ label }) => {
  return (
    <span className="scolab-switcher-loading-indicator" role="status" aria-live="polite">
      <span className="scolab-switcher-loading-visually-hidden">{label}</span>
      <span className="scolab-switcher-loading-dots" aria-hidden="true">
        <span className="scolab-switcher-loading-dot" />
        <span className="scolab-switcher-loading-dot" />
        <span className="scolab-switcher-loading-dot" />
      </span>
    </span>
  );
};

export default LoadingIndicator;
